import React from "react";
import classNames from "classnames";

import { EventKeyBettingOffer } from "@gp/models";

import { OfferTip } from "@features/offer/desktop/buttons";

import { bettingTypesTwoCols, offerInline } from "./BettingTypeRow";

export function TipWrapper(props: {
	tip?: EventKeyBettingOffer;
	bettingTypeAbrv?: string;
}) {
	const { tip, bettingTypeAbrv } = props;

	const tipWrapperClasses = classNames({
		"offer--additional__inline__item":
			!bettingTypesTwoCols.includes(bettingTypeAbrv || "") &&
			!offerInline.includes(bettingTypeAbrv || ""),
		"offer--additional__grid__half": bettingTypesTwoCols.includes(
			bettingTypeAbrv || ""
		),
		"offer--additional__item--full": offerInline.includes(
			bettingTypeAbrv || ""
		),
	});

	return (
		<OfferTip
			tip={tip}
			displayTipName={tip?.displayTip}
			className={tipWrapperClasses}
			tipLabelHasMargin={false}
			isGroupedOfferTip
			isAdditionalOffer={true}
		/>
	);
}
